import React from 'react';

const Dropdown = ({ id, options, title, label, onChange, value, disabled }) => {
  return (
    <div className={`${label ? 'my-[30px]' : ''} w-full`}>
      {label && (
        <div className="mb-[15px]">
          <label htmlFor={id} className="font-playfair text-base font-medium text-black">
            {label}:
          </label>
        </div>
      )}
      <select
        id={id}
        className=" border border-[#E5E7EB] bg-[#F9FAFB] text-black text-base font-normal block w-full py-2 px-4 pe-9 focus:outline-none"
        onChange={onChange}
        value={value}
        disabled={disabled}
      >
        {title ? <option value="">{title}</option> : null}
        {options?.map((item, i) => (
          <React.Fragment key={i}>
            {item?.value !== undefined ? (
              <option value={item.value}>{item.label}</option>
            ) : (
              <option value={item}>{item}</option>
            )}
          </React.Fragment>
        ))}
      </select>
    </div>
  );
};

export default Dropdown;
